const NumberIcon = (props) => {
    return (
        <svg
          width={25}
          height={25}
          viewBox="0 0 25 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <g clipPath="url(#clip0_52_30)" fill="#3C3C3C">
            <path d="M18.844 9.227h-2.54l.327-2.735a.393.393 0 00-.781-.094l-.327 2.829h-4.976l.324-2.735a.395.395 0 00-.344-.437.393.393 0 00-.437.343l-.324 2.829H6.734a.39.39 0 100 .78h2.93l-.586 4.985H6.156a.39.39 0 100 .781h2.828l-.326 2.735a.39.39 0 00.336.437h.047a.39.39 0 00.39-.343l.335-2.829h4.978l-.326 2.735a.39.39 0 00.342.437h.047a.39.39 0 00.39-.343l.336-2.829h2.735a.39.39 0 100-.78h-2.643l.586-4.985h2.633a.39.39 0 000-.781zm-4 5.765H9.857l.586-4.984h4.987l-.586 4.984z" />
          </g>

        </svg>
      )
}

export default NumberIcon